'use client';

import { WorkspaceButton } from '@frameio/primary-nav/components/PrimaryNavButtons/WorkspacesButton';
import { useCurrentPageType } from '@frameio/shared/routing/getPageType';
import { Box, BreadcrumbsSeparator } from '@frameio/vapor';
import { IconPrimaryNavHomeFill } from '@frameio/vapor-icons';

/**
 * Renders the home button

 */
export function HeaderHomeButton() {
  const pageType = useCurrentPageType();
  const isVisible = pageType !== 'folderViewer' && pageType !== 'workspaces';

  return (
    isVisible && (
      <Box alignItems="center" display="flex">
        <WorkspaceButton key="workspace">
          <IconPrimaryNavHomeFill
            aria-hidden={true}
            color="primary"
            size={24}
          />
        </WorkspaceButton>
        <BreadcrumbsSeparator />
      </Box>
    )
  );
}
